import { http } from '@/http/index'

export const getSchedulePosts = async () => http.get('girls/posts/scheduled').then((response) => response.data)
export const getSchedulesList = async () => http.get('girls/posts/calendar').then((response) => response.data)
export const getScheduleByDay = async (day) =>
	http.get(`girls/posts/scheduled/${day}`).then((response) => response.data.data)
